export const personTable = function () {
  return {
    index: true,
    indexLabel: "序号",
    maxHeight: "100%",
    column: [
      {
        label: "姓名",
        prop: "name",
        search: true,
        clearable: true
      },
      {
        label: "性别",
        prop: "sex",
        formatter: function (row, value) {
          if (Number(value) === 0) {
            return "女";
          } else if (Number(value) === 1) {
            return "男";
          } else if (Number(value) === 2) {
            return "未知";
          }
          return "";
        }
      },
      {
        label: "电话",
        prop: "phone",
      },
      {
        label: "照片",
        prop: "img",
      },
      {
        label: "员工类型",
        prop: "personnelMarkName",
      },
      {
        label: "所属群组",
        prop: "personnelGroupName",
      }
    ]
  };
};
